import {useSyncExternalStore} from 'react';

// Module-scoped keyword store (§3, FNP-815): the search input and the list hook that
// filters can live in different components, and both must see one keyword. Built on
// useSyncExternalStore rather than useState + useEffect, so a subscriber mounting
// after a change cannot miss it (the race FNP-605 sweeps out of the other stores).
let keyword = '';
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

const getSnapshot = () => keyword;

const setKeyword = (next: string) => {
    if (next === keyword) return;
    keyword = next;
    listeners.forEach(listener => listener());
};

// The store outlives a render tree, so tests reset it between cases.
export const resetBillableUnitsSearch = () => setKeyword('');

export const useBillableUnitsSearch = () => {
    const current = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

    return {
        keyword: current,
        handleFilterByKeyword: setKeyword,
    };
};
